try {
    window.$ = window.jQuery = require("jquery");
} catch (e) {}

import Datepicker from "flowbite-datepicker/Datepicker";
window.Datepicker = Datepicker;

// Import console messages for developer engagement
import "./console-messages.js";

import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

// Configure Echo - provide fallback if Reverb isn't configured
try {
    if (process.env.MIX_REVERB_APP_KEY) {
        // Use Reverb if configured
        window.Echo = new Echo({
            broadcaster: "reverb",
            key: process.env.MIX_REVERB_APP_KEY,
            wsHost: process.env.MIX_REVERB_HOST,
            wsPort: process.env.MIX_REVERB_PORT ?? 80,
            wssPort: process.env.MIX_REVERB_PORT ?? 443,
            forceTLS: (process.env.MIX_REVERB_SCHEME ?? "https") === "https",
            enabledTransports: ["ws", "wss"],
        });
    } else {
        // Fallback: Create a mock Echo to prevent errors
        window.Echo = {
            private: function () {
                return {
                    listen: function () {},
                    stopListening: function () {},
                };
            },
            channel: function () {
                return {
                    listen: function () {},
                    stopListening: function () {},
                };
            },
            join: function () {
                return {
                    listen: function () {},
                    stopListening: function () {},
                };
            },
            leave: function () {},
            leaveChannel: function () {},
            disconnect: function () {},
            socketId: function () {
                return "mock-socket-id";
            },
        };
    }
} catch (error) {
    console.warn("Echo configuration failed, using mock:", error);
    // Fallback mock if Echo fails to initialize
    window.Echo = {
        private: function () {
            return { listen: function () {}, stopListening: function () {} };
        },
        channel: function () {
            return { listen: function () {}, stopListening: function () {} };
        },
        join: function () {
            return { listen: function () {}, stopListening: function () {} };
        },
        leave: function () {},
        leaveChannel: function () {},
        disconnect: function () {},
        socketId: function () {
            return "mock-socket-id";
        },
    };
}
